import { getLocalizedString } from './get-localized-string.js';

const getLineItemName = (product, locale)=>getLocalizedString(locale, product.masterData.current.name)
;

export { getLineItemName };
//# sourceMappingURL=get-line-item-name.js.map
